import {
  Box,
  Button,
  NewModal
} from '@platform/ui-library';
import { FC } from 'react';
import { useServices, useSubject } from '../hooks';
import LoadingSpinner from '../widgets/components/LoadingSpinner';
import './loading-modal.scss';

/** Used to display when the @see LoadingService is loading. */
export const LoadingModal: FC = () => {
  const { loadingService } = useServices();
  const isLoading = useSubject(
    loadingService.isLoadingChange,
    loadingService.isLoading
  );
  const { message, onCancel } = useSubject(
    loadingService.messageChange,
    loadingService.message
  ) ?? {};

  return (
    <NewModal
      handleClose={() => {
        // The user can not close the loading modal.
      }}
      isOpen={isLoading}
    >
      <Box theme="bigPadding">
        <LoadingSpinner message={message ?? 'Loading...'} />
        {(!onCancel) ? null : (
          <div className="action-container">
            <Button onClick={() => onCancel()}>
              <i className="fe icon-x"></i>
              Cancel
            </Button>
          </div>
        )}
      </Box>
    </NewModal>
  );
};
